<template>
  <div :class="['modal-body', bodyClass]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'ModelBody',
  props: {
    bodyClass: {
      type: String,
      default: ''
    }
  }
}
</script>

